import type { HistoryKind } from '@flashpoint/site-dna';
import type { User } from 'firebase/auth';
import { appendHistoryEntry } from './firestore';
import { scrubForFirestoreValue } from './scrubFirestore';

interface LogParams {
  leadId: string;
  user: User | null;
  kind: HistoryKind;
  payload?: Record<string, unknown>;
}

/**
 * Fire-and-forget history log append. Errors are swallowed (logged to console)
 * so transient failures never block the wizard. Callers must handle success
 * cases via Firestore subscriptions, not the return value.
 */
export function logHistory(params: LogParams): void {
  void appendHistoryEntry(params.leadId, {
    kind: params.kind,
    actorUid: params.user?.uid,
    actorEmail: params.user?.email ?? undefined,
    payload: (scrubForFirestoreValue(params.payload ?? {}) ?? {}) as Record<string, unknown>,
  }).catch((err) => {
    // eslint-disable-next-line no-console
    console.error('[flashpoint] history log append failed', err);
  });
}
